import React from 'react'
import Lang from "@components/Lang/Lang";
import {Input, Row, Col, Dropdown, Image, Pagination, Card, Spin, Empty, Popover,} from 'antd'
import { DownOutlined, } from '@ant-design/icons';
import {postDeliveryDetails, postPurchaserInfo, postFinalPayment,} from '@/api/shipmentOrder'

import './Details.less'

const { Search } = Input
class Details extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            filter: {
                code: '',
                id: this.props.location.state.id,
            },
            extra: {},
            list: [],
            pagination: {
                pageSize: 50,
                total: 0,
                pageIndex: 1
            },
            phoneList: [],
            finalPaymentList: [],
            dropdownStatus: {},
        }
    }

    /** input 中的搜索*/
    onSearch(value) {
        this.setState({
            filter: {
                ...this.state.filter,
                code: value&&value.trim(),
            },
            pagination: {
                ...this.state.pagination,
                pageIndex: 1,
            },
        }, () => {
            this.getList()
        })
    }

    /** pagination 分页器的 onChange*/
    paginationOnChange(page, pageSize) {
        // console.log('Page: ', page, pageSize);
        this.setState({
            pagination: {
                ...this.state.pagination,
                pageIndex: page,
                pageSize: pageSize,
            }
        }, () => {
            this.getList()
        })
    }

    getList() {
        this.setState({
            loading: true
        }, () => {
            postDeliveryDetails({
                ...this.state.filter,
                pagingQuery: {
                    pageIndex: this.state.pagination.pageIndex,
                    pageSize: this.state.pagination.pageSize,
                },
            }).then(res => {
                // console.log(res.data);
                this.setState({
                    extra: res.data.extra,
                    list: res.data.models || [],
                    pagination: {
                        ...res.data.paging,
                        pageIndex: res.data.paging.pageNum
                    },
                    loading: false,
                })
            })
        })
    }

    handleBuyerCode(row) {
        if (this.state.dropdownStatus.buyerId === row.buyerId && this.state.dropdownStatus.type === 'phone') { // 避免重复请求
            return
        }

        this.setState({
            phoneList: [],
        }, () => {
            postPurchaserInfo({
                buyerId: row.buyerId,
                containerId: this.props.location.state.id,
            }).then(res => {
                this.setState({
                    phoneList: res.data.models,
                    dropdownStatus: {
                        buyerId: row.buyerId,
                        type: 'phone'
                    },
                })
            })
        })
    }

    handleFinalPayment(row) {
        if (this.state.dropdownStatus.buyerId === row.buyerId && this.state.dropdownStatus.type === 'finalPayment') { // 避免重复请求
            return
        }
        this.setState({
            finalPaymentList: [],
        }, () => {
            postFinalPayment({
                buyerId: row.buyerId,
                containerId: this.props.location.state.id,
            }).then(res => {
                this.setState({
                    finalPaymentList: res.data.models,
                    dropdownStatus: {
                        buyerId: row.buyerId,
                        type: 'finalPayment'
                    },
                })
            })
        })
    }

    componentDidMount() {
        this.getList()
    }

    render() {
        function showPurchaserInfo(type) {
            if (type === 0) {
                return ( <span className="item-txt-1 mr_34">{Lang({id: 'XiaDanRen', default: '下单人'})}</span>)
            } else if (type === 1) {
                return (<span className="item-txt-1 mr_34">{Lang({id: 'ShouHuoRen', default: '收货人'})}</span>)
            } else {
                return null
            }
        }


        const phoneList = (
            <div>
                <Card title={Lang({id: 'LianXiRenXinXi', default: "联系人信息"})}
                      bordered={false}
                      bodyStyle={{padding: '16px 24px 24px', maxHeight: '380px', overflowY:'auto'}}
                      style={{ width: '479px', }}>
                    {!this.state.phoneList.length && <Spin />}
                    {
                        this.state.phoneList.map((item, index) => (
                            <div className="card-phone-item test" key={index.toString()}>
                                <p data-flex="cross:center" className="mb_10">
                                    <i className="iconfont icon-essa-hd-me mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>
                                    {showPurchaserInfo(item.type)}
                                    <span className="item-txt-2 flex1">{item.name}</span>
                                </p>
                                <p data-flex="cross:center" className="">
                                    <i className="iconfont icon-dianhua mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>
                                    <span className="item-txt-1 mr_16">{Lang({id: 'ShouJiHaoMao', default: '手机号码'})}</span>
                                    <span className="item-txt-2 flex1">{item.mobile}</span>
                                </p>
                            </div>
                        ))
                    }
                </Card>
            </div>
        )

       /* function text() {
            console.log(__getServerDict('fin_remittance_item_state'));
        }
        text()*/

        const finalPaymentList = (
            <div>
                <Card title={Lang({id: 'YingShouWeiKuan', default: "应收尾款"})}
                      bordered={false}
                      bodyStyle={{padding: '16px 24px 24px', maxHeight: '324px', overflowY:'auto'}}
                      style={{ width: '668px', }}>
                    {!this.state.finalPaymentList.length && <Spin />}
                    {this.state.finalPaymentList.map((item, index) => (
                        <div className="card-wei-kuan-item" data-flex="main:justify cross:center" key={index.toString()}>
                            <span style={{color: '#646A73'}}>{Lang({id: 'DingDan', default: '订单'})} {item.poCode}</span>
                            {
                                item.status === 'CONFIRMED'
                                    ? (<span style={{color: '#1F2329'}}>{Lang({id: 'YiZhiFuWeiKuan', default: '已支付尾款'})}：{item.symbol} {parseFloat(item.amountExtra||0).toFixed(2)}</span>)
                                    : null
                            }
                            {
                                item.status === 'TO_BE_CONFIRM'
                                    ? (<span style={{color: '#1F2329'}}>{Lang({id: 'WeiKuan', default: '尾款'})}：{item.symbol} {parseFloat(item.amountExtra||0).toFixed(2)}</span>)
                                    : null
                            }
                        </div>
                    ))}

                </Card>
            </div>
        )

        return (
            <div className="shipment-order-details mt_16">

                {/**/}
                <div className='bg-fff pt_16 pl_16 pr_16'>
                    <p className='top-title mb_24'>{Lang({id: 'ChuHuoDan', default: '出货单'})} {this.props.location.state.code}</p>
                    <div className='mb_16' data-flex='main:justify cross:bottom'>
                        <div className="arrows pt_16 pl_16 pb_16 pr_6">
                            <p className="arrows-txt mb_12">{Lang({id: 'DingDanQingDan', default: '订单清单'})}</p>
                            <p className="arrows-txt">{Lang({id:'ZongGong',default:'总共'})}{this.state.extra.styleCountTotal||0}{Lang({id:'Kuan', default:'款'})}，{this.state.extra.boxCountTotal}{Lang({id:'Xiang',default:'箱'})} , {Lang({id: 'ZongTiJi', default: '总体积',})}: {this.state.extra.volumeTotal}m³</p>
                        </div>
                        <Search placeholder={Lang({id: 'QingShuRuKeHuBianMaHuoShangBinBianMa', default: '请输入客户编码或商品编码'})}
                                onSearch={(value) => this.onSearch(value)}
                                style={{ width: 288 }} />
                    </div>
                    <div className="table-title-box pt_16 pb_16">
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                            <Col span={9}><span className="table-title">{Lang({id: 'ShangPinXinXi', default:'商品信息'})}</span></Col>
                            <Col span={3}><span className="table-title">{Lang({id: 'PODan', default:'PO单'})}</span></Col>
                            <Col span={3}><span className="table-title">{Lang({id: 'TiJi', default:'体积'})}m³</span></Col>
                            <Col span={3}><span className="table-title">{Lang({id: 'DanJia', default:'单价'})}(RUB)</span></Col>
                            <Col span={3}><span className="table-title">{Lang({id: 'XiangShu', default:'箱数'})}</span></Col>
                            <Col span={3}><span className="table-title">{Lang({id: 'JinE', default:'金额'})}</span></Col>
                        </Row>
                    </div>
                </div>

                <Spin spinning={this.state.loading}>
                    {/*列表*/}
                    {this.state.list.map((list) => (
                        <div className="group-box" key={list.buyerId.toString()}>
                            <div className="list-top" data-flex="cross:center">
                                {/*visible={false}*/}
                                <Dropdown overlayClassName='comment-scrollbar' dropdownRender={(menu) =>phoneList} trigger={['click']}>
                                    <a className="font-blue" onClick={this.handleBuyerCode.bind(this, list)}>
                                        {list.buyerCode} <DownOutlined />
                                    </a>
                                </Dropdown>

                                <div data-flex="cross:center" className="flex1">
                                    <p className="ml_14">{Lang({id: 'KuanShu', default: '款数'})} {list.styleCount}</p>
                                    <p className="list-top-line"></p>

                                    <p className="">{Lang({id: 'XiangShu', default: '箱数'})} {list.boxCount}</p>
                                    <p className="list-top-line"></p>
                                    <p>{list.buyerName}</p>
                                </div>

                                {
                                    list.finalPayment > 0
                                        ? (<p className="" data-flex="cross:center">
                                            <span>{Lang({id: 'WeiKuan', default: '尾款'})}：</span>
                                            <Dropdown overlayClassName='comment-scrollbar' dropdownRender={(menu) =>this.finalPaymentList} trigger={['click']}>
                                                <a className="" style={{color: '#1F2329'}} onClick={this.handleFinalPayment.bind(this, list)}>
                                                    {`${list.currencySymbol} ${parseFloat(list.finalPayment||0).toFixed(2)}`}
                                                    <i className="iconfont icon-down ml_8" style={{fontSize: "14px", color: '#646A73'}}></i>
                                                </a>
                                            </Dropdown>
                                        </p>)
                                        : (<span>{Lang({id: 'YiZhiFuWeiKuan', default: '已支付尾款'})}</span>)
                                }
                            </div>

                            <div className="list-content">
                                {list.pos.map((item, index) => (
                                    <div className="list-item" key={index.toString()}>
                                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            <Col span={9}>
                                                <div className="good-info" data-flex="">
                                                    <Image
                                                        className="item-img"
                                                        width={100}
                                                        height={100}
                                                        src={item.picUrl}
                                                    />
                                                    <div className="item-info ml_16">
                                                        <Popover content={item.productName}>
                                                            <p className="item-name mb_8 text-overflow" style={{width: '200px',}}>{item.productName}</p>
                                                        </Popover>
                                                        <p className="item-number">{Lang({id: 'ShangPinBianHao', default: '商品编号'})}: {item.productCode}</p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={3}>{item.poCode}</Col>
                                            <Col span={3}>{item.volume}</Col>
                                            <Col span={3}>{item.currencySymbol} {parseFloat(item.price||0).toFixed(2)}</Col>
                                            <Col span={3}>{item.boxNumber}</Col>
                                            <Col span={3}>{item.currencySymbol} {parseFloat(item.amount||0).toFixed(2)}</Col>
                                        </Row>

                                    </div>
                                ))}

                            </div>
                        </div>
                    ))}

                    {/*无数据*/}
                    {!this.state.list.length && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}


                    {/*分页器*/}
                    <div className="pagination-box">
                        <Pagination showQuickJumper
                                    current={this.state.pagination.pageIndex || 1}
                                    defaultPageSize={this.state.pagination.pageSize}
                                    total={this.state.pagination.total}
                                    showTotal={(total) => `Total ${total} items`}
                                    style={{marginTop: '0'}}
                                    onChange={this.paginationOnChange.bind(this)} />
                    </div>
                </Spin>
            </div>
        )
    }
}

export default Details
